import React from 'react'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import OrdiniFornitore from './OrdiniFornitore'

export default function FornitoreApp() {
  return (
    <Router>
      <Switch>
        <Route path='/' component={OrdiniFornitore} />
      </Switch>
    </Router>
  )
}
